// Component: ImageTextList
// Author: Mito Are
import * as React from 'react';
import { Text, RichText, Image } from '@sitecore-jss/sitecore-jss-react';
import ImageListCard from '@component/ImageListCard';
import { RoutableLink } from '../../react/RoutableLink';
import WBRString from '@component/WbrString';

export default function ImageWithTextCard(props) {
  return (
    <>
      <ImageListCard
        Image={
          <>
            <RoutableLink field={props.fields?.link}>
              <Image field={props.fields?.image} editable={true} imageParams={{ mw: 88, mh: 88 }} height={88} width={88} />
            </RoutableLink>
          </>
        }
        ImageTitle={
          props.fields?.link.value.href !== '' ? (
            <>
              <RoutableLink field={props.fields?.link}>
                <WBRString tag="span">
                  <Text field={props.fields?.title} />
                </WBRString>
              </RoutableLink>
            </>
          ) : (
            <WBRString tag="span">
              <Text field={props.fields?.title} />
            </WBRString>
          )
        }
        richtext={<RichText field={props.fields?.copy} />}
      />
    </>
  );
}
